import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useI18N } from "../../context/I18NContext";
import { useNavigate } from "react-router-dom";
import useWidgetStore from "../../store/useWidgetStore";
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
export default function ConsumerSummary({}) {
    const { t } = useI18N();
    const theme = useTheme();
    const navigate = useNavigate();
    const { consumer } = useWidgetStore();
    const [rows, setRows] = useState([]);
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    useEffect(() => {
        updateRows();
    }, []);
    useEffect(() => {
        updateRows();
    }, [consumer]);
    const updateRows = () => {
        var _a, _b, _c, _d;
        if (consumer) {
            let _rows = [];
            _rows.push([consumer.firstName, consumer.insertions, consumer.lastName].join(' '));
            if (consumer.type === 'business') {
                if ((_a = consumer === null || consumer === void 0 ? void 0 : consumer.business) === null || _a === void 0 ? void 0 : _a.name) {
                    _rows.push((_b = consumer === null || consumer === void 0 ? void 0 : consumer.business) === null || _b === void 0 ? void 0 : _b.name);
                }
                if ((_c = consumer === null || consumer === void 0 ? void 0 : consumer.business) === null || _c === void 0 ? void 0 : _c.city) {
                    _rows.push((_d = consumer === null || consumer === void 0 ? void 0 : consumer.business) === null || _d === void 0 ? void 0 : _d.city);
                }
            }
            else {
                if (consumer.city !== '') {
                    _rows.push(consumer.city);
                }
            }
            if (consumer.email !== '') {
                _rows.push(consumer.email);
            }
            if (consumer.phone && consumer.phone !== '') {
                _rows.push(consumer.phone);
            }
            else if (consumer.mobile && consumer.mobile !== '') {
                _rows.push(consumer.mobile);
            }
            setRows(_rows);
        }
    };
    const goTo = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        navigate(`/oa_widget_${path}`);
    };
    return (_jsx(_Fragment, { children: _jsx(TableContainer, { component: Paper, sx: {
                marginBottom: 4
            }, children: _jsx(Table, { "aria-label": t('Jouw gegevens'), children: _jsx(TableBody, { sx: {
                        "& .MuiTableCell-body": {
                            fontSize: '1rem'
                        }
                    }, children: _jsxs(Fragment, { children: [_jsxs(TableRow, { sx: {
                                    backgroundColor: theme.palette.background.default
                                }, children: [_jsx(TableCell, { colSpan: 3, children: rows === null || rows === void 0 ? void 0 : rows.map((row, i) => (_jsx(Box, { sx: Object.assign({ fontSize: '1.25rem' }, (i === 0 && {
                                                fontWeight: 700
                                            })), children: row }, i))) }), isLarge && (_jsx(TableCell, { sx: { width: '2em' }, align: "right", children: _jsx(IconButton, { onClick: goTo, rel: 'accountDetails1', "aria-label": "edit", size: "medium", children: _jsx(EditIcon, { sx: { color: theme.palette.text.secondary } }) }) }))] }), !isLarge && (_jsx(TableRow, { sx: {
                                    backgroundColor: theme.palette.background.default
                                }, children: _jsx(TableCell, { colSpan: 3, sx: { padding: 0 }, children: _jsx(Button, { fullWidth: true, onClick: goTo, rel: 'accountDetails1', sx: { marginBottom: 2 }, variant: "contained", color: "secondary", children: t('Gegevens wijzigen') }) }) }))] }) }) }) }) }));
}
